import React, { useCallback, useEffect, useState } from 'react'
import CustomButton from '../../Component/CustomButton'
import CustomInputField from '../../Component/CustomInputField'
import Managebtn from '../../Component/Managebtn'
import TimeFrameComp from '../../Component/TimeFrameComp'
import girlimg from "../../images/BUSINESS.9e3478ca41848f9095a6 1.png"
import IncomeForm from './IncomeForm'
import { useNavigate } from 'react-router-dom'
import { useLanguage } from '../../Providers/LanguageContext'
import './Income.css'
function CustomPageForm() {
    const [time, setTime] = useState("day")
    const navigate = useNavigate();
    const { language } = useLanguage();

    const getTime = (val) => {
        setTime(val)
    }
    useEffect(() => {
        window.scrollTo({ top: '0', behavior: 'instant' })
    }, [])

    return (
        <>

            <div style={{
                background: 'linear-gradient(rgb(15, 36, 55),#fff)'
            }}>

                {/* <div className="try_fisibilty_wrapper " style={{
                    transform: 'translateY(0%)',
                    margin: '0px',
                    justifyContent: 'start',
                    background: '#031f31ff'
                }}>
                    <div className="container-fluid">
                        <p className="text-left">Revenue Manager / Post New Income</p> </div>
                </div> */}


                <div className='container-fluid pt-3'>
                    <div className='task_head'> Post New Sales Revenue </div>
                </div>
                <div className='container-fluid'>
                    <div className='mt-3' >
                        <button className=' slctUser' style={{
                        
                        fontWeight:'500',
                        background:'rgb(136, 233, 132)',
                        color:'#0c2637' }} onClick={() => navigate('/editexistingrevenue')}>
                            {language.view_edit}
                        </button>
                    </div>
                </div>
                <div className='container-fluid new_income_Wrapper_main' >

                    <Managebtn white={true} getTime={getTime} value={time} />
                    <div className='row' style={{ paddingBottom: "60px" }}>
                        {/* <TimeFrameComp getTime={getTime} value={time} /> */}


                        {/* <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                            <div style={{ width: "100%", height: "auto" }}>
                                <div style={{ width: "100%", height: "auto" }}>
                                    <div style={{
                                        width: "100%",
                                        height: "auto",
                                        overflow: "hidden",
                                        margin: "40px 10px 10px 10px",
                                        display:'flex',
                                        justifyContent:'center',
                                    }}>
                                        <img src={girlimg} className="img-fluid" style={{ width: "400px", height: "100%", }} />
                                    </div>
                                </div>
                            </div>
                        </div> */}


                        {/* form */}
                        <div className="col-xl-12 col-lg-12 col-md-12 col-12">
                            <IncomeForm setTime={setTime} time={time} />
                        </div>

                        {/* image of right side */}

                    </div>
                </div>
            </div>

        </>
    )
}

export default CustomPageForm;